import { store } from "../../store";
import { createCall } from "../base";
import { plainToClass } from "class-transformer";
import { validate } from "class-validator";

import { BASE_METHODS } from "../../constants/enum";
import { GetMeDTO } from "../../constants/dto/user";
import { timeoutError } from "../../constants/reducer/base-reducer";
import {
  setAdminActionStart,
  setAdminErrorMessage,
} from "../../constants/reducer/user-reducer";
import { CustomErrorType } from "../../constants/action-types";
import { getMeOk } from "../../constants/reducer/session-reducer";

let body: GetMeDTO;

export const modifyProfile = async () => {
  store.dispatch(setAdminActionStart(true));

  const { password, name } = store.getState().user;

    const params = {
        name,
        password
    }

  await createCall(
    "cms/users/modify",
    BASE_METHODS.PUT,
    "application/json",
    params,
    undefined
  )
    .then(async (response) => {
      try {
        body = plainToClass(GetMeDTO, JSON.parse(await response.text()));
      } catch (error) {
        console.log(error);
        return;
      }
      if ((await validate(body)).length > 0) {
        store.dispatch(setAdminErrorMessage("modify-user-profile-invalid-response"));
        return;
      }
      store.dispatch(getMeOk({ user: body.user }));
    })
    .catch((error) => {
        const errorResponeData: CustomErrorType = error;
      if (errorResponeData) {
        let errorMessage = "";
        switch (errorResponeData.code) {
          case 1001:
            errorMessage = "modify-user-profile-user-not-found-response";
            break;
          default:
            break;
        }
        store.dispatch(setAdminErrorMessage(errorMessage));
        return;
      }
      store.dispatch(setAdminActionStart(false));
      store.dispatch(timeoutError());
    });
  return null;
};
